<template>
    <div class="table-footer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="page" 
            :page-sizes="pagesizes" 
            :page-size="limit"
            :layout="layout" 
            :total="total"
            :small="small"
            background
            >
        </el-pagination>
    </div>
        
</template>

<script>
export default {
    name: '',
    props:{
        total:{//数据总条数
            type:Number,
            default:0
        },
        page: {//当前页
            type: Number,
            default: 1
        },
        limit: {//每页条数
            type: Number,
            default: 0
        },
        layout:{//功能
            type:String,
            default:'total, sizes, prev, pager, next, jumper'
        },
        pagesizes:{//当前页显示多少条
            type:Array,
            default:()=>[10,20, 40, 60, 80,100]
        },
        small:{
            type:Boolean,
            default:false
        }

    },
    data() {
        return {
            // total:0,
            // page:1,
            // limit:20,
            // layout:'total, sizes, prev, pager, next, jumper',
            // pagesizes:[15, 20, 30, 40],
        }
    },
    methods: {
        handleSizeChange(val){
            this.$emit('size-change',val)
        },
        handleCurrentChange(val) {

            this.$emit('current-change',val)
        }
    },


}

</script>

<style lang='scss' scoped>

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ED1D24;
    color: #FFF !important;
    height: 25px;
    width: 25px;
    line-height: 25px;
    font-size: 15px;
    // border-radius: 50%;
}
// ::v-deep .el-pager li:hover {
//     color: #ED1D24 !important;
//     height: 25px;
//     width: 25px;
//     line-height: 25px;
//     font-size: 14px;
// }

::v-deep  .el-pager li{
    // background-color: #fff !important;
    margin: 0 5px !important;
    border: 1px solid #dedede;
    height: 25px;
    width: 25px;
    line-height: 25px;
    font-size: 15px;
    // border-radius: 50% !important;
    &:hover{ 
        background-color: #ED1D24 !important;
        color: #FFF !important;
    }
}
::v-deep  .el-pager li:last-child{
   margin: 0 5px !important;
    border: 1px solid #dedede;
    height: 25px;
    width: 25px;
    line-height: 25px;
    font-size: 15px;
}
// ::v-deep  .el-pager li.active{
//     background-color: #ED1D24 !important;

// }

::v-deep .el-pagination .btn-prev {
    height: 25px;
    width: 25px;
    line-height: 25px;
}
::v-deep .el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon{
    height: 25px;
    width: 25px;
    line-height: 25px;
}
</style>